export default __webpack_public_path__ + "fonts/kingvision_icon.2bf9e7f55b166ed4cc456e3f0ff86d5f.png";